import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { theme } from '../../components/global';

class ScrollToTop extends Component {
	componentDidUpdate(prevProps) {
		const { location } = this.props;
		if(location.pathname !== prevProps.location.pathname) {
			setTimeout(() => {
				window.scrollTo(0, 0);
			}, theme.routeTransitions.exitDuration);
		}
	}

	render() {
		const { children } = this.props;
		return children;
	}
}

export default withRouter(ScrollToTop);
